import Device from '@/wrappers/Device';

export class AppService {

    static getAppUrl() {
        const device = Device.get();
        if (device.platform !== 'android') return location.origin;

        const environment = process.env.VUE_APP_ENV;
        let urlPrefix = '';

        if (environment === 'development') {
            urlPrefix = 'dev.';
        } else if (environment === 'staging') {
            urlPrefix = 'staging.';
        }

        const appName = isAllegra ? 'allegrapos' : 'ariapos';
        const localeSuffix = locale === 'sr' ? 'rs' : locale;

        return `https://${urlPrefix}app.${appName}.${localeSuffix}`;
    }
}

export default AppService;
